import clsx from 'clsx';
import { APIRequestItem } from 'api/hooks/use-requests';
import RequestStatus from 'components/request-status';
import ApartmentListItem from 'components/apartment-list-item';
import styles from './styles.module.scss';

type RequestListItemProps = {
  request: APIRequestItem;
  onClick?: () => void;
  className?: string;
};

const RequestListItem: React.FC<RequestListItemProps> = (props) => {
  const {
    request: { id, status, title, createdAtDate, facility: apartment },
    onClick,
    className,
  } = props;

  return (
    <div
      onClick={onClick}
      className={clsx(!!apartment ? styles.container : styles.containerWithoutApartment, className)}
    >
      <div className={styles.requestHeader}>
        <div className={styles.requestNumber}>{`${id} от ${createdAtDate}`}</div>

        <div className={styles.requestTitleContainer}>
          <span className={styles.requestTitle}>{title}</span>
          <RequestStatus status={status} />
        </div>
      </div>

      <>
        {!!apartment ? (
          <ApartmentListItem
            price={apartment.price}
            area={apartment.areaInSqM}
            rooms={apartment.roomCount}
            squarePrice={apartment.pricePerSqM}
            image={apartment.planImage ?? undefined}
            housingEstate={apartment?.apartmentComplexTitle}
            floor={{ floor: apartment.floor, total: apartment.floorCount }}
          />
        ) : null}
      </>
    </div>
  );
};

export const REQUEST_LIST_ITEM_HEIGHT = parseInt(styles.containerHeight);

export default RequestListItem;
